if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button[name="add"]');
        if (!this.button) return;

        this.form = document.getElementById(this.button.getAttribute('form'));
        this.primaryButton = this.form
          ?.closest('product-form')
          ?.querySelector('[name="add"]');
        this.status = this.querySelector('[data-sticky-atc-status]');
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onComplete = this.onComplete.bind(this);

        document.addEventListener('scroll', this.onScroll, { passive: true });
        this.form?.addEventListener('submit', this.onSubmit);
        this.form?.addEventListener('product-form:complete', this.onComplete);

        if (this.primaryButton) {
          this.buttonObserver = new MutationObserver(() => this.syncAvailability());
          this.buttonObserver.observe(this.primaryButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled']
          });
        }

        this.syncAvailability();
        this.checkScroll();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll);
        this.form?.removeEventListener('submit', this.onSubmit);
        this.form?.removeEventListener('product-form:complete', this.onComplete);
        this.buttonObserver?.disconnect();
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        this.animationFrame = requestAnimationFrame(() => this.checkScroll());
      }

      checkScroll() {
        if (this.classList.contains('sticky-atc--after-scroll')) {
          const regularButton = this.closest('section')?.querySelector('.atc-button');
          this.classList.toggle(
            'sticky-atc--active',
            Boolean(regularButton && regularButton.getBoundingClientRect().bottom < 0)
          );
        }
        this.ticking = false;
      }

      onSubmit() {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.setAttribute('aria-busy', 'true');
        this.button.classList.add('loading');
        this.button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        if (this.status) this.status.textContent = '';
      }

      onComplete(event) {
        this.button.classList.remove('loading');
        this.button.removeAttribute('aria-busy');
        this.button.removeAttribute('aria-disabled');
        this.button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        this.syncAvailability();

        if (this.status) {
          this.status.textContent = event.detail?.message || '';
        }
      }

      syncAvailability() {
        if (!this.primaryButton || !this.button) return;
        const isDisabled =
          this.primaryButton.disabled || this.primaryButton.hasAttribute('aria-disabled');
        this.button.toggleAttribute('disabled', this.primaryButton.disabled);
        if (isDisabled) this.button.setAttribute('aria-disabled', 'true');
        else this.button.removeAttribute('aria-disabled');
      }
    }
  );
}
